import React, { createContext, useContext, useRef } from "react";

// Shared handle so the Navbar's "Build Your Box" link can defer to the
// OrderBuilder page (return to the box-style chooser, with a reset warning
// if a build is in progress) instead of a plain navigation.
const OrderNavContext = createContext(null);

export function OrderNavProvider({ children }) {
  const handlerRef = useRef(null);
  return <OrderNavContext.Provider value={handlerRef}>{children}</OrderNavContext.Provider>;
}

export const useOrderNav = () => useContext(OrderNavContext);
